export default __webpack_public_path__ + "static/media/setion04_kv02.a59293ce.png";